import { useRef } from "react";
import { nanoid } from "nanoid";
import cx from "classnames";
import { useKeyPress } from "hooks/common/useKeyPress";
import { ReactPortal } from "components/Common/ReactPortal";
import { Button } from "components/Interactive/Button";
import { IconButton } from "components/Interactive/IconButton";
import { ReactComponent as Close } from "assets/icons/close.svg";

type HomeworkMoveModalProps = {
  open: boolean;
  text: string;
  onClose: () => void;
  onSingleStudent: () => void;
  onAllStudents: () => void;
  loading?: boolean;
};

export const HomeworkMoveModal: React.FC<HomeworkMoveModalProps> = (props) => {
  const {
    open,
    text,
    onClose,
    onSingleStudent,
    onAllStudents,
    loading = false,
  } = props;
  const wrapperIdRef = useRef(`nb-homework-move-modal-${nanoid()}`);

  useKeyPress("Escape", onClose);

  return (
    <ReactPortal wrapperId={wrapperIdRef.current}>
      <div
        aria-hidden={!open}
        tabIndex={-1}
        className={cx([
          "nb-common-action-modal",
          { "nb-common-action-modal--open": open },
        ])}
        onClick={onClose}
      >
        <div
          role="dialog"
          aria-modal
          className={cx([
            "nb-common-action-modal-content",
            { "nb-common-action-modal-content--open": open },
          ])}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="nb-common-action-modal-header">
            <IconButton
              variant="secondary"
              icon={<Close />}
              onClick={onClose}
            />
          </div>
          <div className="nb-common-action-modal-main">
            <p className="nb-common-action-modal-text">{text}</p>
          </div>
          <div className="nb-common-action-modal-footer">
            <Button
              variant="secondary"
              className="nb-common-action-modal-button"
              onClick={onSingleStudent}
              disabled={loading}
            >
              Для обраного студента
            </Button>
            <Button
              variant="primary"
              className="nb-common-action-modal-button"
              autoFocus={open}
              onClick={onAllStudents}
              disabled={loading}
            >
              Для всіх студентів
            </Button>
          </div>
        </div>
      </div>
    </ReactPortal>
  );
};
